import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {EventEmitter, Injectable} from '@angular/core';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {take} from 'rxjs/operators';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FileManagementService} from '@core/services/file-management.service';
import {Router} from '@angular/router';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';

@Injectable({
  providedIn: 'root',
})
export class ScenarioHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  constructor(private commandService: CommandService,
              private router: Router,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService) {
  }

  executeCommand(command: PlatformCommand) {
    if (this.magicLinkModel.fieldValues && this.magicLinkModel.fieldValues['ScenarioType']) {
      command.fieldValues['ScenarioType'] = this.magicLinkModel.fieldValues['ScenarioType'];
    }

    command.projectId = '[PROJECT_ID]';

    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(command, this, null);
        return;
      }
    }
    switch (command.name) {
      default:
        this.executeCommandToApi(command);
        break;
    }

  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[scenario-platform-command] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
          }

          if (commandResponse.fieldValues['FileId']) {
            const fileId = commandResponse.fieldValues['FileId'];
            const fileName = commandResponse.fieldValues['FileName'];

            this.downloadFile(fileId, fileName);
          }

          this.invalidateSubject.invalidate();
        },
        error => {
          console.log(error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private downloadFile(fileId: string, fileName: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
      this.fileManagementService.openSaveFileWindow(payload, fileName);
      this.fuseSplashScreenService.hide();
    });
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
  }

  destroy(): void {
  }

}
